import React, { useEffect, useState } from 'react';
import './style.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import nexusLogo from '../../../assets/images/logotipo.png';
import { useNavigate } from 'react-router-dom';
import { FaCircleNotch } from 'react-icons/fa';
import { API_CONFIG } from '../../../config/api';

function getPasswordStrength(password: string) {
  let score = 0;
  if (password.length >= 10) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) return { label: 'Fraca', color: 'danger', valid: false };
  if (score === 3) return { label: 'Média', color: 'warning', valid: false };
  if (score === 4) return { label: 'Boa', color: 'info', valid: false };
  if (score === 5) return { label: 'Forte', color: 'success', valid: true };
  return { label: 'Fraca', color: 'danger', valid: false };
}

const RedefinirSenha = () => {
  const navigate = useNavigate();
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [confirmarVisivel, setConfirmarVisivel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const strength = getPasswordStrength(senha);
  const senhasIguais = senha === confirmarSenha && senha.length > 0;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (loading) return;
    
    setError('');
    setSuccess(false);

    if (!strength.valid) {
      setError('A senha não é forte o suficiente.');
      return;
    }
    if (!senhasIguais) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    try {
      const body = {
        token: tokenFromUrl,
        email: EmailUser,
        pwd: senha
      };

      const response = await fetch(`${API_CONFIG.BASE_URL}/cadastros/usuarios/redefinir-senha/redefinir`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      if (response.ok) {
        setSuccess(true);
        setSenha('');
        setConfirmarSenha('');

        setTimeout(() => {
          navigate('/login');
        }, 2500);
      } else {
        setError('Falha ao redefinir senha. Tente novamente.');
      }
    } catch {
      setError('Erro ao conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  const queryParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = queryParams.get('token');
  const [EmailUser, setEmailUser] = useState('')
  const [ErrorMessage, setErrorMessage] = useState('')

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/cadastros/usuarios/redefinir-senha/verificador?token=${tokenFromUrl}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();
      const parsedBody = JSON.parse(data.body);

      if (parsedBody.email) {
        setEmailUser(parsedBody.email);
      } else if (parsedBody.message) {
        setErrorMessage(parsedBody.message);
      } else {
        setError('Não foi possivel validar o token de redefinição, por favor tente novamente e caso o erro persista contate o seu time de suporte.')
      }

    } catch (error) {
      setError('Não foi possivel validar o token de redefinição, por favor tente novamente e caso o erro persista contate o seu time de suporte.')
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const SpinnerIcon = FaCircleNotch as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100" style={{ background: 'var(--bs-body-bg)' }}>
      <form className="new_backoffice_user w-100" id="new_backoffice_user" onSubmit={handleSubmit} style={{ maxWidth: 420 }}>
        <div className="d-flex justify-content-center">
          <img
            src={nexusLogo}
            alt="Clicksign"
            width={150}
            style={{ display: 'block', margin: '0 auto' }}
          />
        </div>
        <div className="card mt-4">
          <div className="card-body p-5">
            {(ErrorMessage || error) ? (
              <div className="text-center">
                <h1 className="h4 mb-4 text-danger">Erro</h1>
                <div className="alert alert-danger">{ErrorMessage || error}</div>
              </div>
            ) : (
              <>
                <h1 className="h3 mb-4">Redefinir senha</h1>
                <div className="row mb-3">
                  <div className="col-sm-12 mb-3">
                    <label className="form-label" htmlFor="senha">Nova senha</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type={senhaVisivel ? 'text' : 'password'}
                        id="senha"
                        name="senha"
                        value={senha}
                        onChange={e => setSenha(e.target.value)}
                        required
                        minLength={8}
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        tabIndex={-1}
                        onMouseDown={() => setSenhaVisivel(true)}
                        onMouseUp={() => setSenhaVisivel(false)}
                        onMouseLeave={() => setSenhaVisivel(false)}
                        style={{ borderLeft: 0 }}
                      >
                        {senhaVisivel ? FaEyeSlash({}) : FaEye({})}
                      </button>
                    </div>
                    {senha && (
                      <>
                        <div className={`mt-2 text-${strength.color}`}>Força da senha: <strong>{strength.label}</strong></div>
                        <ul className="small mb-0 mt-1 ps-3">
                          <li className={senha.length >= 10 ? 'text-success' : 'text-danger'}>Mínimo de 10 caracteres</li>
                          <li className={/[A-Z]/.test(senha) ? 'text-success' : 'text-danger'}>Letra maiúscula</li>
                          <li className={/[a-z]/.test(senha) ? 'text-success' : 'text-danger'}>Letra minúscula</li>
                          <li className={/[0-9]/.test(senha) ? 'text-success' : 'text-danger'}>Número</li>
                          <li className={/[^A-Za-z0-9]/.test(senha) ? 'text-success' : 'text-danger'}>Caractere especial</li>
                        </ul>
                      </>
                    )}
                  </div>
                  <div className="col-sm-12">
                    <label className="form-label" htmlFor="confirmarSenha">Confirmar nova senha</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type={confirmarVisivel ? 'text' : 'password'}
                        id="confirmarSenha"
                        name="confirmarSenha"
                        value={confirmarSenha}
                        onChange={e => setConfirmarSenha(e.target.value)}
                        required
                        minLength={8}
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        tabIndex={-1}
                        onMouseDown={() => setConfirmarVisivel(true)}
                        onMouseUp={() => setConfirmarVisivel(false)}
                        onMouseLeave={() => setConfirmarVisivel(false)}
                        style={{ borderLeft: 0 }}
                      >
                        {confirmarVisivel ? FaEyeSlash({}) : FaEye({})}
                      </button>
                    </div>
                    {confirmarSenha && !senhasIguais && (
                      <div className="text-danger mt-2">As senhas não coincidem.</div>
                    )}
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-2 d-flex align-items-center justify-content-center"
                  disabled={loading || !strength.valid || !senhasIguais}
                >
                  {loading ? (
                    <>
                      <SpinnerIcon className="me-2 spinner-icon" />
                      Redefinindo sua senha...
                    </>
                  ) : (
                    'Redefinir senha'
                  )}

                </button>

                {success && (
                  <div className="alert alert-success mt-3">
                    Senha redefinida com sucesso! Redirecionando para a tela de login.
                  </div>
                )}

              </>
            )}
          </div>
        </div>

        <div className="text-center mt-3">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => navigate('/login')}
            disabled={loading}
          >
            Voltar para o login
          </button>
        </div>
      </form>
    </div>
  );
};

export default RedefinirSenha;